// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/profile_type_icons.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ProfileTypeIconService } from "./profile_type_icons";
import type { BulkGetProfileTypeIconsResponse } from "./profile_type_icons";
import type { BulkGetProfileTypeIconsRequest } from "./profile_type_icons";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetProfileTypeIconResponse } from "./profile_type_icons";
import type { GetProfileTypeIconRequest } from "./profile_type_icons";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.assets.v1.ProfileTypeIconService
 */
export interface IProfileTypeIconServiceClient {
    /**
     * @generated from protobuf rpc: GetProfileTypeIcon(c1.api.assets.v1.GetProfileTypeIconRequest) returns (c1.api.assets.v1.GetProfileTypeIconResponse);
     */
    getProfileTypeIcon(input: GetProfileTypeIconRequest, options?: RpcOptions): UnaryCall<GetProfileTypeIconRequest, GetProfileTypeIconResponse>;
    /**
     * @generated from protobuf rpc: BulkGetProfileTypeIcons(c1.api.assets.v1.BulkGetProfileTypeIconsRequest) returns (c1.api.assets.v1.BulkGetProfileTypeIconsResponse);
     */
    bulkGetProfileTypeIcons(input: BulkGetProfileTypeIconsRequest, options?: RpcOptions): UnaryCall<BulkGetProfileTypeIconsRequest, BulkGetProfileTypeIconsResponse>;
}
/**
 * @generated from protobuf service c1.api.assets.v1.ProfileTypeIconService
 */
export class ProfileTypeIconServiceClient implements IProfileTypeIconServiceClient, ServiceInfo {
    typeName = ProfileTypeIconService.typeName;
    methods = ProfileTypeIconService.methods;
    options = ProfileTypeIconService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetProfileTypeIcon(c1.api.assets.v1.GetProfileTypeIconRequest) returns (c1.api.assets.v1.GetProfileTypeIconResponse);
     */
    getProfileTypeIcon(input: GetProfileTypeIconRequest, options?: RpcOptions): UnaryCall<GetProfileTypeIconRequest, GetProfileTypeIconResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetProfileTypeIconRequest, GetProfileTypeIconResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkGetProfileTypeIcons(c1.api.assets.v1.BulkGetProfileTypeIconsRequest) returns (c1.api.assets.v1.BulkGetProfileTypeIconsResponse);
     */
    bulkGetProfileTypeIcons(input: BulkGetProfileTypeIconsRequest, options?: RpcOptions): UnaryCall<BulkGetProfileTypeIconsRequest, BulkGetProfileTypeIconsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkGetProfileTypeIconsRequest, BulkGetProfileTypeIconsResponse>("unary", this._transport, method, opt, input);
    }
}
